import CompanyResource from "./company.resource";

const companyModule = angular
  .module("app.resources.company", [])
  .service("Company", CompanyResource);

export default companyModule;



// WEBPACK FOOTER //
// ./src/resources/company/company.module.js